import React, { useCallback, useEffect, useState } from 'react'
import { DatePicker } from '@shopify/polaris'

const ShopifyDatePicker = props => {

    const today = new Date();
    const someDay = new Date();
    const disabledBefore = new Date();

    someDay.setDate(today.getDate() + 7)
    disabledBefore.setDate(today.getDate() - 1)

    const [{ date, month, year }, setDate] = useState({ data: today.getDate() - 1, month: today.getMonth(), year: today.getFullYear() });
    const [selectedDates, setSelectedDates] = useState({ start: today, end: someDay });
    const [{ before }] = useState({ before: disabledBefore });

    useEffect(() => {
        if (Object.keys(props.SelectedDates).length) {
            setSelectedDates(props.SelectedDates)
        }
    }, [])

    useEffect(() => {
        props.setSelectedDates(selectedDates)
    }, [selectedDates])

    const handleMonthChange = useCallback(
        (month, year) => setDate({ date, month, year }),
        [],
    );


    return (
        <DatePicker
            month={month}
            year={year}
            onChange={setSelectedDates}
            onMonthChange={handleMonthChange}
            selected={selectedDates}
            disableDatesBefore={before}
            allowRange
        />
    )
}

export default ShopifyDatePicker